export const communityDiscussions = [
  {
    id: "1",
    title: "What Makes a Dish Truly 'Continental'?",
    excerpt:
      "Is it the ingredients, the technique, or the philosophy? Our community weighs in on what continental cuisine means in today's global kitchen.",
    category: "Discussion of the Week",
    author: "Meera Banerjee",
    responses: 47,
    featured: true,
  },
  {
    id: "2",
    title: "Your First Memory of European Coffee",
    excerpt:
      "Share the story of your first real European coffee experience — where were you, what did you drink, and how did it change you?",
    category: "Food Questions",
    author: "Community Member",
    responses: 32,
    featured: false,
  },
  {
    id: "3",
    title: "Which Continental Dish Should We Add to The Table?",
    excerpt:
      "Our chef is exploring new dishes for the autumn menu. Vote for your favorite and tell us why it deserves a place at Cafe Courtyard.",
    category: "Food Polls",
    author: "Chef Arjun Mehta",
    responses: 89,
    featured: false,
  },
  {
    id: "4",
    title: "The Art of Slow Dining: Why We Need to Reclaim the Table",
    excerpt:
      "In an age of fast everything, our community reflects on why slow, intentional dining matters more than ever.",
    category: "Community Opinions",
    author: "Ritika Sen",
    responses: 56,
    featured: false,
  },
  {
    id: "5",
    title: "From Your Kitchen to Ours: Home Recipes We Love",
    excerpt:
      "Community members share their family recipes that have continental roots — passed down, adapted, and loved.",
    category: "Featured Conversations",
    author: "Community Member",
    responses: 41,
    featured: false,
  },
];

export const featuredConversation = {
  quote:
    "Some cafes serve coffee. Cafe Courtyard serves conversations that stay with you long after the cup is empty. I came for the Chicken Ala Kiev and stayed for the stories.",
  author: "Anirban Chatterjee",
  role: "Regular at the Courtyard since 2024",
  image:
    "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Indian%20man%20in%20casual%20elegant%20attire%20sitting%20in%20cafe%20setting%2C%20warm%20natural%20lighting%2C%20genuine%20smile%2C%20editorial%20lifestyle%20photography%20style%2C%20coffee%20cup%20in%20hand%2C%20cozy%20atmosphere&width=500&height=650&seq=community-anirban&orientation=portrait",
};